import React from 'react';

const ModalTitle = (props) => {
    return (<div className="mod-title" {...props}>{props.title}</div>);
};

export default ModalTitle;


// WEBPACK FOOTER //
// ./src/components/common/modalTitle.js